import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  fetchChargingTokenDesigns: ['offset'],
  fetchChargingTokenDesignsLoading: null,
  fetchChargingTokenDesignsSuccess: [
    'offset',
    'chargingTokenDesigns',
    'nextOffset',
  ],
  fetchChargingTokenDesignsError: ['error'],

  fetchAllChargingTokenDesigns: ['offset', 'designName'],
  fetchAllChargingTokenDesignsLoading: null,
  fetchAllChargingTokenDesignsSuccess: [
    'offset',
    'chargingTokenDesigns',
    'nextOffset',
  ],
  fetchAllChargingTokenDesignsError: ['error'],

  addChargingTokenDesign: ['design'],
  addChargingTokenDesignLoading: null,
  addChargingTokenDesignSuccess: ['design'],
  addChargingTokenDesignError: ['error'],

  editChargingTokenDesign: ['id', 'design'],
  editChargingTokenDesignLoading: null,
  editChargingTokenDesignSuccess: ['design'],
  editChargingTokenDesignError: ['error'],

  getChargingTokenDesignsCount: null,
  getChargingTokenDesignsCountLoading: null,
  getChargingTokenDesignsCountSuccess: ['chargingTokenCount'],
  getChargingTokenDesignsCountError: ['error'],

  deleteChargingTokenDesign: ['id'],
  deleteChargingTokenDesignLoading: null,
  deleteChargingTokenDesignSuccess: ['id'],
  deleteChargingTokenDesignError: ['error'],

  clearDesigns: null,
  resetAllDesigns: null,
})

export const ChargingTokenDesignTypes = Types
export default Creators
